import React from 'react';
import Availability from './components/Availability';

const Index = () => {
  return (
    <Availability />
  );
};

export default Index;